module.exports = __webpack_public_path__ + "assets/69d556e0fc11e1cc0eff1f4b80e52016.mp3";